import EfTitle from '@elem/ui/ef-title';
import EfWhatInBox from '@elem/ui/ef-what-in-box-b';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
// import { useRouter } from 'next/router';

export default function TheComp() {
    const { t } = useLang('rapid.WhatInBox');
    // const { locale } = useRouter();

    const listA = [
        {
            title: t('a_title'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725354884809/wib_01.png',
        },
        {
            title: t('c_title'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725354279703/wib_03.png',
        },
        {
            title: t('d_title'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725354279826/wib_04.png',
        },
    ];
    return (
        <div className={css.comp}>
            <EfSpec />
            <EfTitle>{t('title')}</EfTitle>
            <EfWhatInBox list={listA} position="num4" />
            <EfSpec />
        </div>
    );
}
